import { Injectable, OnInit } from '@angular/core';
import { Observable, Observer, Subject, Subscription, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { Season, Course, Run, Ninja, FirestoreReference, Obstacle } from 'src/app/Classes/schema';
import { AnwLogsService } from '../Loggers/anw-logs.service';
import { AnwService } from '../ANW/anw.service';
import { QueryFn } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  constructor(
    private logger: AnwLogsService,
  ) { }

  seasons: cachedANW<Season>;
  ninjas: cachedANW<Ninja>;
  obstacles: cachedANW<Obstacle>;
  courses: cachedANW<Course>;
  runs: cachedANW<Run>;

  init(anw: AnwService) {
    this.logger.log("Breadcrumbs initiated");
    this.seasons = new cachedANW<Season>(anw);
    this.ninjas = new cachedANW<Ninja>(anw);
    this.obstacles = new cachedANW<Obstacle>(anw);
    this.courses = new cachedANW<Course>(anw);
    this.runs = new cachedANW<Run>(anw);
    return this;
  }

  getCollection(collectionId: string): cachedANW<any> {
    const allowedCollections = ['seasons', 'courses', 'runs', 'ninjas', 'obstacles'];
    if (allowedCollections.indexOf(collectionId) >= 0) {
      return this[collectionId] as cachedANW<any>;
    }
    this.logger.log(`---- collection [${collectionId}] not found!`);
    return null;
  }
}

class cachedANW<T> {
  private anw: AnwService;

  private _collectionId: string;
  private _collectionFromDB: Observable<FirestoreReference<T>[]>;
  private _currentCollection: FirestoreReference<T>[];
  private _collectionEmitter: Observer<FirestoreReference<T>[]>;
  private _collection$: Subscription;
  public collectionExport: Observable<FirestoreReference<T>[]>;

  private _queryArg: string;
  private _queryVal: string;

  public query: QueryFn;

  private _documentId: string;
  private _currentDocument: FirestoreReference<T>;
  private _documentEmitter: Observer<FirestoreReference<T>>;
  public documentExport: Observable<FirestoreReference<T>>;

  constructor(anw: AnwService) {
    this.anw = anw;
    this._collectionEmitter = new Subscriber();
    this._documentEmitter = new Subscriber();
    this.collectionExport = Observable.create(e => {
      this._collectionEmitter = e
    });
    this.documentExport = Observable.create(e => {
      this._documentEmitter = e
    });
    this.query = ref => ref;

    this._collectionFromDB = new Observable();

    this._collection$ = new Subscription();
  }

  currentDoc() {
    return this._currentDocument;
  }

  currentCollection() {
    return this._currentCollection;
  }

  syncToDB() {
    this._collection$.unsubscribe();
    const colId = this._collectionId;
    this._collectionFromDB = this.anw.fhs.getAll<T>(colId, this.query);
    this._collection$ = this._collectionFromDB.subscribe(refs => {
      this.anw.log("-- new collection coming in from db");
      this._currentCollection = refs;
      // this.anw.log(this._currentCollection);
      this._collectionEmitter.next(this._currentCollection);
      if (this._documentId) {
        this.anw.log("-- new document coming in from db");
        this._currentDocument = this._currentCollection.find(ref => ref.id === this._documentId);
        // this.anw.log(this._currentDocument);
        this._documentEmitter.next(this._currentDocument);
      }
    });
  }

  setColId(newId: string) {
    if (this._collectionId !== newId) {
      this.anw.log(`-- scanning db for collection ${newId}`);
      this._collectionId = newId;
      this.syncToDB()
    } else {
      this.anw.log(`-- using cached results for collection ${newId}`);
      this._collectionEmitter.next(this._currentCollection);
    }
  }

  setQuery(queryArg: string, queryVal: any, orderArg: string | null | string[], isDesc: boolean | boolean[]) {
    if (queryArg !== this._queryArg || queryVal !== this._queryVal) {
      this.anw.log("---- changing query");
      this._queryArg = queryArg;
      this._queryVal = String(queryVal);
      if (!queryArg) {
        this.anw.log("------ querying for all ", queryArg)
        this.query = ref => ref;
      } else if (!orderArg) {
        this.anw.log("------ querying where ", queryArg, " equals ", queryVal);
        this.query = ref => ref.where(queryArg, "==", queryVal);
      } else if (orderArg instanceof Array) {
          this.query = ref => orderArg.reduce((query, arg, index) => 
            query.orderBy(arg, isDesc[index] ? "desc": "asc")
          , ref.where(queryArg, "==", queryVal))
      } else {
        this.anw.log("------ querying where ", queryArg, " equals ", queryVal, " ordered by ", orderArg, " in ", (isDesc ? "descending" : "ascending"), " order");
        this.query = ref => ref.where(queryArg, "==", queryVal).orderBy(orderArg, isDesc ? "desc" : "asc");
      }
      this.syncToDB();
    } else {
      this.anw.log("---- no change to query");
    }
  }

  // public pingCollection() {
  //   Promise.resolve()
  //     .then(() => {
  //       this.anw.log("---- Sending out collection")
  //       this.anw.log(this._currentCollection);
  //       this._collectionEmitter.next(this._currentCollection)
  //     })
  //     .then(() => {
  //       this.anw.log("---- Sending out document");
  //       this.anw.log(this._currentDocument);
  //       this._documentEmitter.next(this._currentDocument);
  //     })
  // }

  setdocumentId(newId: string) {
    if (this._documentId !== newId) {
      this.anw.log("-- scanning through cached db for document");
      this._documentId = newId;
      this._currentDocument = this._currentCollection.find(ref => ref.id === this._documentId);
      this.anw.log(this._currentDocument);
      this._documentEmitter.next(this._currentDocument);
    } else {
      this.anw.log(`-- using cached result for document ${newId}`);
      this._documentEmitter.next(this._currentDocument);
    }
  }
}

class myObserver<T> implements Observer<T>{
  next = (value) => {
    console.log("------ Emitting");
    console.log(value);
    // console.log("---- observer fired");
    // console.log(value);
  }
  error = (err) => {
    console.log("!!!! error!")
    console.log(err);
  }
  complete = () => {
    console.log("---- observer complete");
  }
}